import React from 'react';
import { ArrowsClockwise } from '@phosphor-icons/react';
import { Switch } from 'antd';
import { useDashboardV3Data } from './useDashboardV3Data';
import { useOneButtonStore } from '../../../../../../store/oneButtonStore';

export type DashboardV3PartnerSyncSectionProps = {
    onOpenSyncStatus?: () => void;
};

export const DashboardV3PartnerSyncSection: React.FC<DashboardV3PartnerSyncSectionProps> = ({
    onOpenSyncStatus,
}) => {
    const { partnerSyncRows } = useDashboardV3Data();
    const setCommerceHubProductsOpen = useOneButtonStore((s) => s.setCommerceHubProductsOpen);

    return (
        <section className="obd-dashboard-v3-layout__partner-sync" aria-label="Finance partner sync">
            <div className="obd-v3-partner-sync-card">
                <header className="obd-v3-partner-sync-card__head">
                    <h2 className="obd-dashboard-v3-layout__section-title obd-v3-partner-sync-card__title">
                        Finance Partner Sync
                    </h2>
                    <button
                        type="button"
                        className="obd-v3-partner-sync-card__status-btn"
                        onClick={onOpenSyncStatus}
                        title="View sync status"
                    >
                        <ArrowsClockwise size={16} weight="bold" aria-hidden />
                        Sync Status
                    </button>
                </header>
                <ul className="obd-v3-partner-sync-list">
                    {partnerSyncRows.map((row) => (
                        <li key={row.id} className="obd-v3-partner-sync-row">
                            <div className="obd-v3-partner-sync-row__main">
                                <span className="obd-v3-partner-sync-row__name">{row.name}</span>
                                <span className="obd-v3-partner-sync-row__detail">{row.statusDetail}</span>
                            </div>
                            <div className="obd-v3-partner-sync-row__stats">
                                <span>
                                    <strong>{row.quotesCount}</strong> Quotes
                                </span>
                                <span>
                                    <strong>{row.signedCount}</strong> Signed
                                </span>
                            </div>
                            <div className="obd-v3-partner-sync-row__status">
                                {row.status === 'connected' ? (
                                    <span className="obd-v3-partner-sync-row__badge obd-v3-partner-sync-row__badge--connected">
                                        Connected
                                    </span>
                                ) : row.status === 'pending' ? (
                                    <span className="obd-v3-partner-sync-row__badge obd-v3-partner-sync-row__badge--pending">
                                        Pending
                                    </span>
                                ) : (
                                    <Switch
                                        size="small"
                                        checked={false}
                                        disabled={!row.enabled}
                                        onChange={() => setCommerceHubProductsOpen(true)}
                                        aria-label={`${row.name} sync`}
                                    />
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};
